"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./src/index");
exports.Angular2FontawesomeModule = index_1.Angular2FontawesomeModule;



//////////////////
// WEBPACK FOOTER
// ./~/angular2-fontawesome/angular2-fontawesome.js
// module id = 296
// module chunks = 9